import {AUSTRALIA_COUNTRIES, MapDifficultyLevel} from "../types";

// function print() {
//   const codes: string[] = []
//   for (const name of [
//   "Australia","Fiji","New Caledonia","New Zealand","Papua New Guinea","Solomon Islands", "Vanuatu"
//   ]) {
//     console.log(name);
//     const country = ALL_COUNTRIES.find(c => c.name === name);
//     codes.push(`$CC("${country.cc}")`);
//   }
//   console.log(codes.join(", "));
// }
// print();
export class AustraliaDifficultyLevel extends MapDifficultyLevel {

  static readonly VALUES = new Array<AustraliaDifficultyLevel>(1);
  static readonly MEDIUM = AustraliaDifficultyLevel.VALUES[0] = new AustraliaDifficultyLevel("medium", "Medium", "Medium desc", AUSTRALIA_COUNTRIES);
}